module.exports = __webpack_public_path__ + "img/selected5-min.fffd657b.png";